import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { z } from 'zod';
import { BlockCard } from '../lib/block-card.js';
import { cx } from '../lib/cx.js';
import { STATE_BG_CLASS, STATE_TONES } from '../lib/state-styles.js';
const BarSchema = z
    .object({
    label: z.string(),
    value: z.string().optional(),
    percent: z.number().min(0).max(100),
    state: z.enum(STATE_TONES).optional(),
})
    .strict();
export const BarChartPropsSchema = z
    .object({
    title: z.string().optional(),
    bars: z.array(BarSchema),
})
    .strict();
/** Renders a `bar_chart` block — simple horizontal percent bars. */
export function BarChartPrimitive({ title, bars }) {
    return (_jsx(BlockCard, { title: title, children: _jsx("div", { className: "space-y-2", children: bars.map((bar, index) => (_jsxs("div", { children: [_jsxs("div", { className: "mb-1 flex items-baseline justify-between gap-2 text-xs", children: [_jsx("span", { className: "text-foreground", children: bar.label }), bar.value ? (_jsx("span", { className: "tabular-nums text-muted-foreground", children: bar.value })) : null] }), _jsx("div", { className: "h-2 w-full overflow-hidden rounded-full bg-muted", children: _jsx("div", { className: cx('h-2 rounded-full', STATE_BG_CLASS[bar.state ?? 'neutral']), style: { width: `${bar.percent}%` } }) })] }, index))) }) }));
}
